<template>
  <div class="problem">
    <div class="problem-item" v-if="!isComplete">
      <div class="type">{{ $t('lang.mz.two.questions.title') }}</div>
      <div
        class="question"
        v-show="que.id === current"
        v-for="(que, i) in questions"
        :key="que.id"
      >
        <div class="question-title">
          {{ $t(que.question) }}
        </div>
        <div class="question-options">
          <el-radio-group v-model="que.answer">
            <el-radio
              v-for="option in que.options"
              :key="option.value"
              :label="option.value"
              :disabled="currentIndex == i"
            >
              {{ $t(option.label) }}
            </el-radio>
          </el-radio-group>
        </div>
        <div class="question-btn">
          <div class="btn" @click="handleSubmit(i)" v-if="!isAnswer">
            {{ $t('lang.mz.two.questions.determine') }}
          </div>
          <div class="btn" @click="nextQuestion" v-else>
            {{ $t('lang.mz.two.questions.NextQ') }}
          </div>
        </div>
      </div>
      <div class="tip" :class="{ 'tip-n': !answerResult }" v-show="isAnswer">
        <img
          :src="
            answerResult
              ? serverURL + 'images/answer_tip_y.png'
              : serverURL + 'images/answer_tip_n.png'
          "
          alt=""
        />
        {{
          answerResult
            ? $t('lang.mz.two.questions.tipSuccess')
            : $t('lang.mz.two.questions.tipError')
        }}
      </div>
    </div>
    <div class="popconfirm" v-else>
      <img :src="serverURL + 'images/tip-icons@2x.png'" alt="" />
      <p>
        {{ $t('lang.mz.two.questions.over') }} <font>{{ score }}</font>
      </p>
      <p v-show="son !== 20">
        {{ $t('lang.mz.two.questions.NextInteraction') }}
      </p>
      <div v-show="son == 20">
        <div class="btn" @click="$router.go(-1)">
          {{ $t('lang.index.exper_header.backButton') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { expRecord, recordInfo } from '@/api/experimentation/test'
import { lang } from '@/language/language-zh.js'
export default {
  name: 'problem',
  components: {},
  props: ['questions', 'son'],
  data() {
    return {
      current: 0,
      isAnswer: false,
      isComplete: false,
      answerResult: false,
      params: {
        course_id: window.localStorage.getItem('expId') || 1,
        son_course_id: null,
        stepRecord: [],
        expTotalScore: 0,
        spendSecond: 0,
      },
      score: 0,
      isSubmit: false,
      startTimer: null,
      endTimer: null,
      submitQue: [],
      currentIndex: null
    }
  },
  watch: {},
  computed: {
    serverURL() {
      return this.publicData.serverUrl
    },
  },
  created() {
    this.initQue()
  },
  mounted() {
    this.params.son_course_id = this.son
    this.getRecord()
    this.startTimer = Date.now()
  },
  methods: {
    handleSubmit(i) {
      if (
        this.questions[this.current].answer ===
        this.questions[this.current].result
      ) {
        this.questions[this.current].scored = this.questions[this.current].score
        this.answerResult = true
      } else {
        this.questions[this.current].scored = 0
        this.answerResult = false
      }
      this.isAnswer = true
      this.currentIndex = i
    },
    nextQuestion() {
      this.currentIndex = null
      if (this.current < this.questions.length - 1) {
        this.current++
        this.isAnswer = false
      } else {
        this.isComplete = true
        this.submitResult()
      }
    },
    submitResult() {
      this.endTimer = Date.now()
      let time = Math.floor((this.endTimer - this.startTimer) / 1000)
      this.params.spendSecond = time
      let stepRecord = []
      let score = 0
      this.questions.forEach((v, i) => {
        stepRecord.push({
          result: v.result == v.answer,
          answer: v.answer,
          options: this.submitQue[i].options,
          question: this.submitQue[i].question,
          scored: v.scored,
          correct: v.result,
        })
        score += v.scored
      })
      this.score = score
      this.params.stepRecord = JSON.stringify(stepRecord)
      this.$store.commit('SET_SCORE_MODULE', {
        id: this.son,
        score: this.score,
      })
      this.params.expTotalScore = score
      this.$emit('submit')
      if (this.isSubmit) return console.log(this.params)
      expRecord(this.params).then((res) => {
        const { score } = res.data
        this.$store.commit('SET_SCORE', score)
        this.$notify({
          type: 'success',
          message: '提交成功！',
          duration: 1500,
          title: 'SUCCESS',
        })
      })
    },
    getRecord() {
      let token = window.localStorage.getItem('token')
      if (!token) return (this.isSubmit = true)
      let expId = window.localStorage.getItem('expId') || 1
      recordInfo(expId).then((res) => {
        const { record, score } = res.data
        this.$store.commit('SET_SCORE', score)
        record.forEach((v) => {
          if (v.id === this.son) {
            this.isSubmit = v.me_record.length ? true : false
          }
        })
      })
    },
    initQue() {
      let submitQue = []
      switch (this.son) {
        case 20:
          submitQue.push(lang.mz.two.questions.first)
          submitQue.push(lang.mz.two.questions.second)
          this.submitQue = submitQue
          break
        case 21:
          submitQue.push(lang.ct.one.ll_child.firstQ)
          submitQue.push(lang.ct.one.ll_child.secondQ)
          submitQue.push(lang.ct.one.ll_child.thirdQ)
          submitQue.push(lang.ct.one.ll_child.fourthQ)
          this.submitQue = submitQue
          break
        case 22:
          submitQue.push(lang.ct.two.one.ll_child.first)
          submitQue.push(lang.ct.two.one.ll_child.second)
          this.submitQue = submitQue
          break
        case 23:
          submitQue.push(lang.ct.two.two.ll_chird.firstQ)
          submitQue.push(lang.ct.two.two.ll_chird.secondQ)
          this.submitQue = submitQue
          break
        case 24:
          submitQue.push(lang.ct.two.three.ll_child.firstQ)
          submitQue.push(lang.ct.two.three.ll_child.secondQ)
          this.submitQue = submitQue
          break
        case 25:
          submitQue.push(lang.ct.two.four.ll_child.firstQ)
          submitQue.push(lang.ct.two.four.ll_child.secondQ)
          this.submitQue = submitQue
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.problem {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &-item {
    width: 48%;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0px 2px 24px 0px rgba(221, 241, 255, 0.49);
    border-radius: 5px;
    position: relative;
    .type {
      color: #444444;
      font-weight: bold;
      font-size: 1.15vw;
      line-height: 3;
      text-align: center;
      border-bottom: 2px solid #f0bbbb;
    }
    .question {
      width: 100%;
      padding: 4.8% 8%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &-options {
        width: 100%;
        // padding: 2.8vh 0;
        .el-radio-group {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
        }
        .el-radio {
          min-width: 50%;
          max-width: 100%;
          white-space: normal;
          flex-shrink: 0;
          margin-right: 0;
          margin: 20px 0;
        }
      }
      &-btn {
        display: flex;
        justify-content: center;
      }
    }
    .tip {
      position: absolute;
      top: -100px;
      left: 50%;
      transform: translateX(-50%);
      background-image: var(--tip-bg);
      background-size: 100% 100%;
      width: fit-content;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 40px 10px;
      font-size: 1.25vw;
      font-weight: bold;
      color: #a63528;
      img {
        width: 65px;
        margin-right: 22px;
      }
    }
    .tip-n {
      background-image: var(--tipn-bg);
      // padding: 5px 40px;
    }
  }
}
</style>